import React from 'react';
import HomeSection from './Home/index.jsx';
import MeetSection from './Meet/index.jsx';
import FeaturesSection from './Features/index.jsx';
import AutomationSection from './Automation/index.jsx';
import FoundingMembersSection from './FoundingMembers/index.jsx';
import TestimonialsSection from './Testimonials/index.jsx';

const MainSectoion = () => {

  return (
    <div className="home">
      {/* Hero Section */}
      <HomeSection />

      {/* Meet Section */}
      <MeetSection />

      {/* Features Section */}
      <FeaturesSection />

      {/* Automation Section */}
      <AutomationSection />

      {/* Founding Members Section */}
      <FoundingMembersSection />

      {/* Testimonials Section */}
      <TestimonialsSection />
    </div>
  );
};

export default MainSectoion; 
